import { Component, OnInit } from '@angular/core';
import { DataSharingService } from '../services/data-sharing.service';
import { StudentService } from '../services/student.service';
import { StudentPost } from '../models/student-post';

@Component({
  selector: 'past-student-info',
  templateUrl: './past-student-info.component.html',
  styleUrls: ['./past-student-info.component.css']
})
export class PastStudentInfoComponent implements OnInit {
  student: StudentPost;
  classes: any;
  // classHistoryUI: string[] =  [] ;
  htmlToAdd: string;

  constructor(
    private _dataService: DataSharingService,
    private _studentService: StudentService) {
    this.getData();
  }

  getData() {
    this.student = this._dataService.getCurrentStudent().student;
  }

  ngOnInit() {
    this._studentService.getStudentClasses(this.student.studentLoginId)
    .subscribe(
      classes => this.getClassesSuccess(classes),
        error => this.getClassesFailed(error),
        () => console.log('Completed!')); // comment
  }

  getClassesSuccess(classes: any) {
    this.classes = classes;
    this.htmlToAdd = '<table id="tableResults" class="table table-striped"> <thead> <tr class="tr"> <th class="th">Class Date</th> <th class="th">Class Type</th> <th>Location of Class</th> </tr> </thead>';
    for (let c of this.classes) {
      this.htmlToAdd += '<tr  class="tr"> <td class="td">' + new Date(c.classSchedule.startDateTime).toISOString().split('T')[0] + '</td> <td class="td">' + c.classSchedule.classMaster.description + '</td> <td>' + c.classSchedule.location.description + '</td> </tr>';
    }
    this.htmlToAdd += ' </table>';
  }

   getClassesFailed(error: any) {
    console.log('Failed!');
  }
}



// WEBPACK FOOTER //
// ./src/app/past-student-info/past-student-info.component.ts